// src/store/slices/hierarchySlice.ts
// Caches the current, editable officer-hierarchy role list — populated once on
// auth-init and refreshed whenever an admin edits it (role:updated socket event).
// Kept in Redux (not TanStack Query) because badges/dropdowns across the app
// need synchronous, always-available lookups by roleId, same as the old
// hardcoded ROLES/PRI consts they replace.

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RoleEntry } from 'types/rbac';

interface HierarchyState {
  roles: RoleEntry[];
  loaded: boolean;
}

const initialState: HierarchyState = {
  roles: [],
  loaded: false,
};

const hierarchySlice = createSlice({
  name: 'hierarchy',
  initialState,
  reducers: {
    setRoles: (state, action: PayloadAction<RoleEntry[]>) => {
      state.roles = [...action.payload].sort((a, b) => a.hierarchyLevel - b.hierarchyLevel);
      state.loaded = true;
    },
  },
});

export const { setRoles } = hierarchySlice.actions;
export default hierarchySlice.reducer;
